<div class="relative inline-block">
  <button
    type="button"
    class="flex items-center gap-2 px-2 py-1 text-gray-800 bg-white border border-gray-300 rounded-md cursor-pointer hover:bg-gray-50 hover:border-gray-400 disabled:opacity-60 disabled:cursor-not-allowed"
    [disabled]="isDisabled()"
    (click)="toggleDropdown(); $event.stopPropagation()"
  >
    <i class="material-symbols-outlined !text-2xl">filter_alt</i>
  </button>

  <p-multiSelect
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue() ?? undefined"
    [filterBy]="filterBy() ?? optionLabel()"
    [showClear]="showClear()"
    [(ngModel)]="value"
    [disabled]="isDisabled()"
    [showToggleAll]="true"
    [overlayVisible]="visible"
    (onHide)="visible = false"
    (onChange)="onSelect($event)"
    (onClear)="onClear()"
    appendTo="body"
  >
    <ng-template let-option pTemplate="item">
      <div class="flex items-center">
        <div
          *ngIf="option.color"
          class="w-2.5 h-2.5 mr-2 rounded-full inline-block"
          [style.background-color]="option.color"
        ></div>
        <span>{{ option[optionLabel()] }}</span>
      </div>
    </ng-template>
  </p-multiSelect>
</div>
